import { EntityType } from 'api'
import { createEntityGetterHook, createEntityHook } from './common'
import { createReferenceDataEntityHook } from './referenceData'

export const useProductSectorMapping = createEntityHook(EntityType.PRODUCT_SECTOR_MAPPING_DRAFT)
export const useProductSectorMappingGetter = createEntityGetterHook(EntityType.PRODUCT_SECTOR_MAPPING_DRAFT)
export const useProductSectorMappingReferenceData = createReferenceDataEntityHook(EntityType.PRODUCT_SECTOR_MAPPING_DRAFT)
